import { post } from '@hummingbirdtechgroup/wings-request';

const postNewUpload = (apiUrl, payload) => {
  return post(apiUrl, '/v1/uav-uploads/new', payload);
};

export default postNewUpload;
